import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const Anvandarvillkor = lazy(() => import("@/pages/info/Anvandarvillkor"));

export const Route = createFileRoute("/anvandarvillkor")({
  head: () => seoHead("/anvandarvillkor", { description: "Dessa villkor reglerar din användning av Elmarknad.se, våra jämförelse- och offerttjänster samt våra verktyg. Läs dem innan du använder tjänsten." }),
  component: () => <Anvandarvillkor />,
});
